import { signal } from '@angular/core';

const SPRITE_ID = 'hx-shared-icon-sprite';

function createSpriteState() {
  return {
    status: signal<'idle' | 'loading' | 'ready' | 'failed'>('idle'),
  };
}

type SpriteDocument = Document & { __hxSharedIconSprite?: ReturnType<typeof createSpriteState> };

export function getIconSprite(document: Document) {
  const owner = document as SpriteDocument;
  const state = (owner.__hxSharedIconSprite ??= createSpriteState());

  return {
    status: state.status.asReadonly(),
    load(): void {
      if (state.status() !== 'idle' || !document.defaultView) return;
      if (document.getElementById(SPRITE_ID)) {
        state.status.set('ready');
        return;
      }

      state.status.set('loading');
      void fetch('/assets/icons/complexcare-icons.svg', { cache: 'force-cache' })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to load icon sprite');
          return response.text();
        })
        .then((source) => {
          const parsed = new DOMParser().parseFromString(source, 'image/svg+xml');
          if (parsed.querySelector('parsererror') || parsed.documentElement.localName !== 'svg') {
            throw new Error('Invalid icon sprite');
          }
          const sprite = document.importNode(parsed.documentElement, true);
          sprite.id = SPRITE_ID;
          sprite.setAttribute('aria-hidden', 'true');
          sprite.setAttribute('focusable', 'false');
          sprite.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none');
          document.body.prepend(sprite);
          state.status.set('ready');
        })
        .catch(() => state.status.set('failed'));
    },
  };
}
